/**
 * Base URL for AI / pipeline services (audits, client media, AI Planner event-media/captions, etc.).
 * Override with REACT_APP_AI_API_BASE_URL when pointing at a custom backend.
 */
const SERVER_URL =
  process.env.REACT_APP_SERVER_URL || "https://api-login-dev.rategainsoho.com"

export const AI_BASE_URL =
  process.env.REACT_APP_AI_API_BASE_URL ||
  (SERVER_URL.includes("dev")
    ? "https://api-login-dev.rategainsoho.com"
    : "https://api-login.rategainsoho.com")

/** Sent as `X-API-Key` on all {@link AI_BASE_URL} requests. Override with REACT_APP_AI_API_KEY. */
export const AI_API_KEY =
  process.env.REACT_APP_AI_API_KEY ||
  "817f29ab511763fd192641e9ad11ef746db384a1cd93aa21819ff276d6bdf5a8"

export function isAiBaseUrl(url) {
  const base = String(AI_BASE_URL || "").replace(/\/$/, "")
  if (!base || !url) return false
  return String(url).startsWith(base)
}

export function aiApiKeyHeaders() {
  if (!AI_API_KEY) return {}
  return { "X-API-Key": AI_API_KEY }
}

/**
 * Pipelines HTTP origin (no path suffix). Same default host as `lib/request.js` for `/api/v1/*`.
 * `ai-planner-preferences` and similar routes live here, not on {@link AI_BASE_URL} (api-login).
 * Override with `REACT_APP_PIPELINES_API_BASE_URL` when pipelines and `REACT_APP_SERVER_URL` differ.
 */
export const PIPELINES_ORIGIN = String(
  process.env.REACT_APP_PIPELINES_API_BASE_URL ||
    process.env.REACT_APP_SERVER_URL ||
    "https://pipelines-dev.rategainsoho.com",
)
  .trim()
  .replace(/\/$/, "")
